import {useInjection} from "inversify-react";
import {useCallback, useEffect, useState} from "react";
import ApiService from "../../services/apiService";
import {AddressApi, AddressCreateDto, AddressDto, AddressUpdateDto} from "../../api";
import AddressModalFormAddContainer from "./addressModalFormAddContainer/addressModalFormAddContainer";
import {Layout, message} from "antd";
import {Content} from "antd/lib/layout/layout";
import styles from "./addressListContainer.module.scss";
import AddressesList from "./addressList";
import {useParams} from "react-router-dom";

export default function AddressesListContainer() {
    const apiService = useInjection(ApiService);
    const [addresses, setAddresses] = useState<AddressDto[] | null>();
    const [isAddFormVisible, setAddFormVisible] = useState(false);
    const [addressModalFormContainerTitle, setAddressModalFormContainerTitle] = useState<string>();
    const [addressToEdit, setAddressToEdit] = useState<AddressUpdateDto | null>(null);
    const [idAddressToEdit, setIdAddressToEdit] = useState<number | null>(null);
    const [isLoading, setIsLoading] = useState<boolean>(false);
    const {userId} = useParams();

    const refreshAddressesList = async () => {
        setIsLoading(true);
        try {
            const Addresses = await apiService.getApi(AddressApi)
                .apiAddressUserAddressesUserIdGet(+userId!);
            setAddresses(Addresses.data);
        } catch (e: any) {
            console.log(e.response.data);
        }

        setIsLoading(false);
    }

    useEffect(() => {
        refreshAddressesList();
    }, []);

    const onAddClicked = () => {
        setAddressModalFormContainerTitle("Dodaj nowy adres");
        setAddressToEdit(null);
        setIdAddressToEdit(null);
        setAddFormVisible(true);
    }

    const onEditClicked = useCallback(async (id: number) => {
        setAddressModalFormContainerTitle('Edytuj adres');
        try {
            setIsLoading(true);

            const response = await apiService.getApi(AddressApi)
                .apiAddressIdGet(id);

            setAddressToEdit(response.data as AddressUpdateDto);
            setIdAddressToEdit(id);
            setAddFormVisible(true);
        } catch (e: any) {
            return e.response?.data;
        } finally {
            setIsLoading(false);
        }
    }, [apiService]);

    const onDeleteClicked = useCallback(async (id: number) => {
        try {
            await apiService.getApi(AddressApi).apiAddressIdDelete(id);
            message.success("Pomyślnie usunięto adres");
            await refreshAddressesList();
        } catch (e: any) {
            message.error("Wystąpił błąd podczas usuwania adresu");
            return e.response?.data;
        }
    }, [apiService]);

    const onSubmit = useCallback(async (values: AddressCreateDto | AddressUpdateDto) => {
        try {
            if (addressToEdit === null) {
                values.applicationUserId = +userId!;
                await apiService.getApi(AddressApi).apiAddressPost(values);
            } else if (idAddressToEdit !== null) {
                values.applicationUserId = +userId!;
                await apiService.getApi(AddressApi).apiAddressIdPut(idAddressToEdit, values);
            }
            await refreshAddressesList();
        } catch (e: any) {
            return e.response.data;
        } finally {
            setAddFormVisible(false);
        }
    }, [apiService, idAddressToEdit]);

    return <Layout style={{backgroundColor: "white"}}>
        <Content>
            <Layout>
                <Content className={styles.content}>
                    <AddressesList
                        data={addresses || null}
                        onAddClicked={onAddClicked}
                        onEditClicked={onEditClicked}
                        onDeleteClicked={onDeleteClicked}
                    />
                    <AddressModalFormAddContainer
                        onFinish={() => setAddFormVisible(false)}
                        onSubmit={onSubmit}
                        addFormVisibility={isAddFormVisible}
                        title={addressModalFormContainerTitle || ""}
                        AddressToEdit={addressToEdit}
                    />
                </Content>
            </Layout>
        </Content>
    </Layout>;
}
